.panelHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid var(--mantine-color-gneis-1);
}

.commentList {
    list-style: none;
    padding: 0;
    margin: 0;
}

.commentGroup {
    border-bottom: 1px solid var(--mantine-color-gneis-1);
    padding: 1rem 1.25rem;

    &:hover {
        background-color: hsl(195, 20%, 96%);
    }

    &.focused {
        border-left: 3px solid var(--mantine-color-gneis-5);
        background-color: var(--mantine-color-gneis-0);
        padding-left: calc(1.25rem - 3px);
    }
}

.commentTitle {
    color: #333;
    display: block;
    font-weight: bold;
    font-size: var(--mantine-font-size-sm);
    line-height: 1.5rem;
    margin: 0.5rem 0;
    overflow: hidden;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;

    .focused & {
        color: var(--mantine-color-gneis-5);
    }

    &:hover {
        text-decoration: underline;
    }
}

.commentItem {
    display: flex;
}

.initials {
    flex-shrink: 0;
    width: 2rem;
    height: 2rem;
    font-size: var(--mantine-font-size-xs);
    line-height: 2rem;
    text-align: center;
    color: #333;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: hsl(195, 20%, 96%);
    border-radius: 50%;
    margin-right: 0.75rem;
}

.commentWrapper {
    flex: 1;
}

.commentMeta {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
}

.username {
    font-weight: bold;
    font-size: var(--mantine-font-size-sm);
}

.timestamp {
    color: var(--mantine-color-dimmed);
    font-size: var(--mantine-font-size-xs);
    margin-left: 0.75rem;
}

.commentTextarea {
    background-color: transparent;
    border-radius: 0.25rem;
    border: none;
    padding: 0.5rem;
    margin: 0 0 0 -0.5rem;
    resize: vertical;
    width: 100%;
    font-family: inherit;
    font-size: inherit;

    &:hover,
    &:focus {
        box-shadow: 0 0 0 1px var(--mantine-color-gneis-1);
    }

    &:focus {
        background-color: white;
        outline: none;
    }
}
